// extracted by mini-css-extract-plugin
export default {"root":"CatalogBindings_root__UXzpw","table":"CatalogBindings_table__390Tq","id":"CatalogBindings_id__ZeI8D"};